import {DASHBOARD, ENQUIRY_LABEL, PROJECTS_LABEL, SERVICES_LABEL} from "Components/constants/commonNames";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
    const history = useNavigate();
    
    const[isEnquiry,setIsEnquiry] = useState<boolean>(false)
    const[isProjects,setIsProjects] = useState<boolean>(false)
    // const[isService,setIsService] = useState<boolean>(false)
    const [iscurrentState, setIscurrentState] = useState(DASHBOARD);

    function updateIconSidebar(e : any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul : any = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove("twocolumn-panel");
        if (iscurrentState !== DASHBOARD) {
        setIsProjects(false);
        }
    }, [
        history,
        iscurrentState,
        // isService,
        isProjects,
        isEnquiry,
       
    ]);

    const menuItems : any = [

        {
            id: "projects",
            label: PROJECTS_LABEL,
            icon: "mdi mdi-cube-outline",
            link: "/projects",
            stateVariables: isProjects,
            click: function (e : any) {
                e.preventDefault();
                setIsProjects(!isProjects);
                setIscurrentState(PROJECTS_LABEL);
                updateIconSidebar(e);
            },
        },
//? For FUTURE  FUNCTIONS
        // {
        //     id: "services",
        //     label: "Services",
        //     icon: "mdi mdi-cogs",
        //     link: "/services",
        //     stateVariables: isService,
        //     click: function (e : any) {
        //         e.preventDefault();
        //         setIsService(!isService);
        //         setIscurrentState(SERVICES_LABEL);
        //         updateIconSidebar(e);
        //     },  
        // },
        {
            id: "enquiry",
            label: ENQUIRY_LABEL,
            icon: "mdi mdi-calendar-multiple",
            link: "/inquiry",
            stateVariables: isEnquiry,
            click: function (e : any) {
                e.preventDefault();
                setIsEnquiry(!isEnquiry);
                setIscurrentState(ENQUIRY_LABEL);
                updateIconSidebar(e);
            },
            
        },
    
    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
